<template>
  <div class="container-fluid">
    <div class="px-5" v-show="false">
      <v-layout row wrap class="mb-4">
        <v-flex xs12 class="pr-0">
          <el-card class="box-card">
            <div slot="header" class="clearfix">
              <span class="font-weight-bold">ยอดขายรายวัน (เดือนนี้)</span>
            </div>
            <apexchart
              type="bar"
              height="180"
              :options="barChartOptions"
              :series="seriesMonth"
            ></apexchart>
          </el-card>
        </v-flex>
      </v-layout>
      <v-layout row wrap class="mb-4">
        <v-flex xs12 sm12 md8 class="pr-2">
          <el-card class="box-card">
            <div slot="header" class="clearfix">
              <span class="font-weight-bold">ยอดขายตามช่วงเวลา</span>
            </div>
            <apexchart
              type="bar"
              height="180"
              :options="barChartOptions"
              :series="seriesHour"
            ></apexchart>
          </el-card>
        </v-flex>
        <v-flex xs12 sm12 md4 class="pl-2">
          <el-card class="box-card">
            <div slot="header" class="clearfix">
              <span class="font-weight-bold">ยอดขายตามช่วงวัน</span>
            </div>
            <apexchart
              type="bar"
              height="180"
              :options="barChartOptions"
              :series="seriesDay"
            ></apexchart>
          </el-card>
        </v-flex>
      </v-layout>
      <v-layout row wrap>
        <v-flex xs12 sm12 md4 class="pr-2">
          <el-card class="box-card">
            <div slot="header" class="clearfix">
              <span class="font-weight-bold">สินค้าขายดี</span>
            </div>
          </el-card>
        </v-flex>
        <v-flex xs12 sm12 md4 class="pr-2 pl-2">
          <el-card class="box-card">
            <div slot="header" class="clearfix">
              <span class="font-weight-bold">โปรโมชั่น</span>
            </div>
          </el-card>
        </v-flex>
        <v-flex xs12 sm12 md4 class="pr-0 pl-2">
          <el-card class="box-card">
            <div slot="header" class="clearfix">
              <span class="font-weight-bold">ลูกค้า</span>
            </div>
          </el-card>
        </v-flex>
      </v-layout>
    </div>
  </div>
</template>
<script>
import Service from "@/services";
export default {
  components: {},
  data: () => ({
    seriesMonth: [
      {
        name: "ยอดขาย",
        data: [
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
        ],
      },
    ],
    seriesHour: [
      {
        name: "ยอดขาย",
        data: [
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
        ],
      },
    ],
    seriesDay: [
      {
        name: "ยอดขาย",
        data: [0, 0, 0, 0, 0, 0, 0],
      },
    ],
    chartOptionsDay: {
      chart: {
        type: "bar",
        height: 200,
        toolbar: {
          show: false,
        },
      },
      plotOptions: {
        bar: {
          horizontal: false,
          columnWidth: "55%",
        },
      },
      dataLabels: {
        enabled: false,
      },
      stroke: {
        show: true,
        width: 2,
        colors: ["transparent"],
      },
      xaxis: {
        categories: ["จ.", "อ.", "พ.", "พฤ.", "ศ.", "ส.", "อา."],
      },
      yaxis: {
        title: {
          text: "THB",
        },
      },
      fill: {
        opacity: 1,
      },
      tooltip: {
        y: {
          formatter: function(val) {
            return "THB";
          },
        },
      },
    },
    chartOptions: {
      chart: {
        toolbar: {
          show: false,
        },
      },
      dataLabels: {
        enabled: false,
      },
      stroke: {
        show: true,
        curve: "smooth",
        width: 5,
        colors: ["#FF0000", "D32F2F"],
      },
      xaxis: {
        categories: [
          "00",
          "01",
          "02",
          "03",
          "04",
          "05",
          "06",
          "07",
          "07",
          "08",
          "10",
          "11",
          "12",
          "13",
          "14",
          "15",
          "16",
          "17",
          "18",
          "19",
          "20",
          "21",
          "22",
          "23",
          "24",
          "25",
          "26",
          "27",
          "28",
          "29",
          "30",
          "31",
        ],
      },
      yaxis: {
        title: {
          text: "THB",
        },
        labels: {
          show: true,
          align: "right",
          minWidth: 0,
          maxWidth: 160,
          offsetX: 0,
          offsetY: 0,
          rotate: 0,
          formatter: (value) => {
            return value
              .toFixed(2)
              .toString()
              .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
          },
        },
      },
      fill: {
        type: "gradient",
        gradient: {
          shade: "dark",
          gradientToColors: ["#FDD835"],
          shadeIntensity: 1,
          type: "horizontal",
          opacityFrom: 1,
          opacityTo: 1,
          stops: [0, 100, 100, 100],
        },
      },
      markers: {
        size: 4,
        colors: ["#D32F2F"],
        strokeColors: "#fff",
        strokeWidth: 2,
        hover: {
          size: 7,
        },
      },
      tooltip: {
        y: {
          formatter: function(val) {
            return "THB thousands";
          },
        },
      },
    },
    barChartOptions: {
      chart: {
        toolbar: {
          show: false,
        },
      },
      dataLabels: {
        enabled: false,
      },
      stroke: {
        show: false,
        curve: "smooth",
        width: 5,
        colors: ["#ccc", "#ccc"],
      },
      xaxis: {
        categories: [
          "00",
          "01",
          "02",
          "03",
          "04",
          "05",
          "06",
          "07",
          "07",
          "08",
          "10",
          "11",
          "12",
          "13",
          "14",
          "15",
          "16",
          "17",
          "18",
          "19",
          "20",
          "21",
          "22",
          "23",
          "24",
          "25",
          "26",
          "27",
          "28",
          "29",
          "30",
          "31",
        ],
      },
      yaxis: {
        title: {
          text: "THB",
        },
        labels: {
          show: true,
          align: "right",
          minWidth: 0,
          maxWidth: 160,
          offsetX: 0,
          offsetY: 0,
          rotate: 0,
          formatter: (value) => {
            return value
              .toFixed(2)
              .toString()
              .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
          },
        },
      },
      fill: {
        colors: ["#e13210", "#e13210"],
        type: "solid",
        gradient: {
          gradientFromColors: ["#e13210"],
          gradientToColors: ["#e13210"],
          shadeIntensity: 1,
          shade: "light",
          type: "horizontal",
          opacityFrom: 1,
          opacityTo: 1,
          stops: [0, 90, 100],
        },
      },
      markers: {
        size: 4,
        colors: ["#e13210"],
        strokeColors: "#fff",
        strokeWidth: 2,
        hover: {
          size: 7,
        },
      },
      tooltip: {
        y: {
          formatter: function(val) {
            return (
              val
                .toFixed(2)
                .toString()
                .replace(/\B(?=(\d{3})+(?!\d))/g, ",") + " THB"
            );
          },
        },
      },
    },
  }),
  created() {
    /*
    let params = {
      begin: "2020-05-20",
      end: "2020-05-27",
      report: true,
      type: "view",
    };
    */
    //this.thisMonth();
  },
  methods: {
    thisMonth() {
      Array.prototype.sum = function(prop) {
        var total = 0;
        for (var i = 0, _len = this.length; i < _len; i++) {
          total += parseFloat(this[i][prop]);
        }
        return total;
      };

      Service.Stat.statMonth({}).then((res) => {
        /* month view */
        let months = Object.values(
          res.data.reduce((a, { day_of_year, ...props }) => {
            if (!a[day_of_year])
              a[day_of_year] = Object.assign(
                {},
                { day_of_year, items: [props] }
              );
            else a[day_of_year].items.push(props);
            return a;
          }, {})
        );

        console.log(months);
        let monthData = this.seriesMonth[0].data;
        months.map((item, index) => {
          item.items.map((row) => {
            monthData[index] += parseFloat(row.total_food);
          });
          //monthData[index] = item.items.sum("total_food");
        });

        console.log(monthData);

        this.seriesMonth = [
          {
            data: monthData,
          },
        ];

        /* hour view */
        let hours = Object.values(
          res.data.reduce((a, { hours, ...props }) => {
            if (!a[hours])
              a[hours] = Object.assign({}, { hours, items: [props] });
            else a[hours].items.push(props);
            return a;
          }, {})
        );

        let hourData = this.seriesHour[0].data;
        hours.map((item) => {
          hourData[item.hours] = item.items.sum("total_food");
        });

        this.seriesHour = [
          {
            data: hourData,
          },
        ];

        /* day view */
        let day_of_week = Object.values(
          res.data.reduce((a, { day_of_week, ...props }) => {
            if (!a[day_of_week])
              a[day_of_week] = Object.assign(
                {},
                { day_of_week, items: [props] }
              );
            else a[day_of_week].items.push(props);
            return a;
          }, {})
        );

        let dayData = this.seriesDay[0].data;
        day_of_week.map((item) => {
          dayData[item.day_of_week] = item.items.sum("total_food");
        });

        this.seriesDay = [
          {
            data: dayData,
          },
        ];
      });

      /*
      let params = {
        begin: moment().startOf("month").format("YYYY-MM-DD"),
        end: moment().format("YYYY-MM-DD"),
      };

      var queryString = Object.keys(params)
        .map((key) => key + "=" + params[key])
        .join("&");

      Service.Enterprise.getSaleReport(
        this.reference,
        queryString
      ).then((res) => {});
      */
    },
  },
};
</script>
